export function getChangedGameOrderPositions(
	previousGameOrder: Record<string, string | null>,
	updatedGameOrder: Record<string, string | null>
): string[] {
	const allPositions = new Set([...Object.keys(previousGameOrder), ...Object.keys(updatedGameOrder)]);
	return Array.from(allPositions).filter(position => (previousGameOrder[position] ?? null) !== (updatedGameOrder[position] ?? null));
}
